import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireActiveSubscription, requireAuth } from '@/lib/middleware'
import { OnboardingManagementPage } from '@/features/onboarding-management'

export const Route = createFileRoute('/_authenticated/_organization/onboarding/management/')({
  beforeLoad: async () => {
    await requireAuth()
    await requireActiveSubscription()
  },
  component: OnboardingManagementRoute,
})

function OnboardingManagementRoute() {
  const navigate = useNavigate()
  const { data: activeMember } = authClient.useActiveMember()
  const memberRole = activeMember?.role

  // Restrict to admin/owner roles
  if (memberRole && memberRole !== 'owner' && memberRole !== 'admin') {
    navigate({ to: '/' })
    return null
  }

  return <OnboardingManagementPage />
}

